<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="员工姓名" prop="employeeName">
        <el-input
          v-model="queryParams.employeeName"
          class="!w-240px"
          clearable
          placeholder="请输入员工姓名"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="排班日期" prop="shiftDate">
        <el-date-picker
          v-model="queryParams.shiftDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择排班日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="班次类型" prop="shiftType">
        <el-select
          v-model="queryParams.shiftType"
          class="!w-240px"
          clearable
          placeholder="请选择班次类型"
        >
          <el-option label="早班" value="MORNING" />
          <el-option label="中班" value="AFTERNOON" />
          <el-option label="夜班" value="NIGHT" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:schedule:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="员工姓名" prop="employeeName" min-width="100" />
      <el-table-column align="center" label="岗位编码" prop="positionCode" min-width="100" />
      <el-table-column align="center" label="排班日期" prop="shiftDate" min-width="120" />
      <el-table-column align="center" label="班次类型" prop="shiftType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.shiftType === 'MORNING'" type="primary">早班</el-tag>
          <el-tag v-else-if="scope.row.shiftType === 'AFTERNOON'" type="success">中班</el-tag>
          <el-tag v-else-if="scope.row.shiftType === 'NIGHT'" type="info">夜班</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间" prop="startTime" min-width="100" />
      <el-table-column align="center" label="结束时间" prop="endTime" min-width="100" />
      <el-table-column align="center" label="是否休息" prop="restDay" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.restDay === 1" type="warning">休息</el-tag>
          <el-tag v-else type="success">上班</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 0" type="info">待排班</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="primary">已排班</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="success">已签到</el-tag>
          <el-tag v-else-if="scope.row.status === 3" type="success">已签退</el-tag>
          <el-tag v-else-if="scope.row.status === 4" type="danger">已缺勤</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:schedule:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:schedule:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="员工" prop="employeeId">
        <el-select v-model="formData.employeeId" placeholder="请选择员工" filterable>
          <el-option v-for="item in employeeList" :key="item.id" :label="item.name + ' (' + item.employeeNo + ')'" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="排班日期" prop="shiftDate">
        <el-date-picker
          v-model="formData.shiftDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择排班日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="班次类型" prop="shiftType">
        <el-radio-group v-model="formData.shiftType">
          <el-radio value="MORNING">早班</el-radio>
          <el-radio value="AFTERNOON">中班</el-radio>
          <el-radio value="NIGHT">夜班</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-input v-model="formData.startTime" placeholder="如 08:00" />
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-input v-model="formData.endTime" placeholder="如 16:00" />
      </el-form-item>
      <el-form-item label="是否休息" prop="restDay">
        <el-radio-group v-model="formData.restDay">
          <el-radio :value="0">上班</el-radio>
          <el-radio :value="1">休息</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="formData.remark"
          :rows="3"
          placeholder="请输入备注"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as ScheduleApi from '@/api/hotel/schedule'
import { getEmployeeListAll } from '@/api/hotel/employee'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelSchedule' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

// 员工下拉列表
const employeeList = ref<any[]>([])
const getEmployeeList = async () => {
  const data = await getEmployeeListAll()
  employeeList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  employeeName: undefined,
  shiftDate: undefined,
  shiftType: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await ScheduleApi.getSchedulePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<ScheduleApi.ScheduleVO>({
  id: undefined,
  shopId: undefined,
  employeeId: 0,
  employeeName: '',
  positionCode: '',
  shiftDate: '',
  shiftType: 'MORNING',
  startTime: '',
  endTime: '',
  restDay: 0,
  status: 0,
  remark: '',
  createTime: undefined as any
})
const formRules = reactive({
  employeeId: [{ required: true, message: '员工不能为空', trigger: 'blur' }],
  shiftDate: [{ required: true, message: '排班日期不能为空', trigger: 'change' }],
  shiftType: [{ required: true, message: '班次类型不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await ScheduleApi.getSchedule(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await ScheduleApi.createSchedule(data)
      message.success(t('common.createSuccess'))
    } else {
      await ScheduleApi.updateSchedule(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: 0,
    employeeId: 0,
    employeeName: '',
    positionCode: '',
    shiftDate: '',
    shiftType: 'MORNING',
    startTime: '',
    endTime: '',
    restDay: 0,
    status: 0,
    remark: '',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await ScheduleApi.deleteSchedule(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getEmployeeList()
  getShopList()
})
</script>
